import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { I18n } from "react-redux-i18n";
import { Icons, Label, DropMenu } from "cakemail-ui-components/lib/react";
import {
	updateAutomationEvent,
	deleteAutomationEvent,
	updateSelectedEvent,
	openSubScene,
} from "assets/js/data/automations/actions";
import { Handle, isEdge } from "react-flow-renderer";
import { useEffect } from "react";
import { EDITOR_MODE } from "assets/js/const/Automations";
import {
	SEGMENT_EVENTS,
	trackSegmentEvent,
} from "assets/js/const/SegmentEvents";
import { Translate } from "react-redux-i18n";
import { useLayoutEffect } from "react";

const NodeBase = (props) => {
	let classes = props.id == props.selectedEventId ? "node selected" : "node";
	let containerClasses = "";
	if (props.editorMode == EDITOR_MODE.NUMBERING) {
		containerClasses = "extraPadding ";
		if (
			props.automationEvents
				.filter((e) => e.data.baseId == "loop" && e.id == props.selectedEventId)
				.filter((event) => event.data.goTo == props.id).length > 0
		) {
			containerClasses = "loopedTo";
		} else if (props.data.numberIdentifer) {
			containerClasses = "numbered";
		}
	}

	classes =
		props.editorMode === EDITOR_MODE.VALIDATION
			? props.hasErrors === "resolved"
				? classes + " resolved hasErrors"
				: classes
			: classes;
	classes =
		props.editorMode === EDITOR_MODE.VALIDATION
			? props.hasErrors == "errors"
				? classes + " hasErrors"
				: classes
			: classes;
	classes =
		props.automationErrors.length > 0 &&
			props.editorMode === EDITOR_MODE.VALIDATION &&
			!props.data.type.includes("helper")
			? classes + " validationNode"
			: classes;
	const [showOptionsMenu, setShowOptionsMenu] = useState(false);
	const menuRef = React.useRef();
	useEffect(() => {
		if (showOptionsMenu)
			if (menuRef.current && document.activeElement !== menuRef.current) {
				menuRef.current.focus();
			}
		const elements = document.getElementsByClassName("react-flow__node");
		try {
			if (elements)
				for (var i = 0; i < elements.length; i++) {
					let e = elements.item(i);
					if (e.getAttribute("data-id") == props.data.id && showOptionsMenu)
						e.style.setProperty("z-index", "99999");
					else e.style.removeProperty("z-index");
				}
		} catch (error) { }
	}, [menuRef.current, showOptionsMenu]);
	useLayoutEffect(() => { }, []);
	const onNodeClick = (e) => {
		if (props.onClick) props.onClick();
		// we just need to stop propagation in case we are in the validator mode, and the element doesn't have any issues
		else if (!props.hasErrors && props.editorMode === EDITOR_MODE.VALIDATION)
			e.stopPropagation();
	};
	return (
		<div onClick={onNodeClick} className={containerClasses}>
			{!props.data.initialElement && (
				<Handle type="target" id="a1" position="top" className="targetHandle">
					<Icons
						className="the-svg-icons"
						name="micro-glyph-arrow2"
						type="framed-icon-ext-2"
					/>
				</Handle>
			)}
			<div
				className={props.data.baseId}
				style={props.styles ? props.styles : {}}
			>
				{props.editorMode === EDITOR_MODE.NUMBERING &&
					props.data.numberIdentifer && (
						<p className="numbering-label">{props.data.numberIdentifer}</p>
					)}
				<div className={classes}>
					{showOptionsMenu && (
						<div
							onBlur={(e) => {

								setShowOptionsMenu(false);
							}}
							tabIndex="0"
							role="button"
							ref={menuRef}
						>
							<DropMenu
								className="nodeMenuOptions"
								align="left"
								values={[
									// hiding for now till the function is avaible for step again
									// {
									// 	label: (
									// 		<div className="node-options">
									// 			<p>Add contacts</p>
									// 			<Icons name="glyph-add-contact" />
									// 		</div>
									// 	),
									// 	onClick: (e) => {
									// 		e.stopPropagation();
									// 		setShowOptionsMenu(false);
									// 		props.openSubScene("contactsListing", {
									// 			stepId: props.previousStepId,
									// 		});
									// 		props.data.setSidePanels([]);
									// 	},
									// },

									{
										label: (
											<div className="node-options">
												<p>{I18n._translate("app-general-delete")}</p>
												<Icons name="glyph-trash" />
											</div>
										),
										disabled: props?.activeAutomation?.status === "active" || props.editorMode === EDITOR_MODE.VALIDATION,
										onClick: (e) => {
											e.stopPropagation();
											setShowOptionsMenu(false);
											if (typeof props.deleteAttachedRessources === "function") {
												props.deleteAttachedRessources();
											}
											props.data.deleteNode(props.id);
											props.data.setSidePanels([]);
											trackSegmentEvent(
												SEGMENT_EVENTS[
												`AUTOMATION_${props.data.type.toUpperCase()}_ADDED`
												],
												{
													automationId: props.activeAutomation.id,
													type: props.data.baseId,
													id: props.id,
													deleted_on: Date.now(),
												}
											);
										},
									},
								]}
							/>
						</div>
					)}
					<div className={`content  ${props.data.type}`}>
						<div className="nodeBody">
							{props.content ? (
								props.content
							) : (
								<p>
									<b>
										{props.data.tileTitle || props.tileTitle ? (
											<Translate
												value={props.data.tileTitle || props.tileTitle}
												data={props.params}
												count={props.params}
											/>
										) : props.data.desc || props.desc ? (
											props.data.desc || props.desc
										) : null}
									</b>
								</p>
							)}
							{props.showFooter && (
								<div className="nodeFooter">
									<Icons
										className={`the-svg-icons ${props.data.type}`}
										name={props.footerIcon}
										type="icon"
									/>
									{props.footerStats != null ? (
										<p className="mice narrow">
											<Translate
												data={props.footerStats}
												value={
													props.footerStats == 1
														? "app-general-person"
														: "app-general-ppl"
												}
											/>
											<Translate
												value={`app-automation-editor_events_${props.data.baseId}-1_footerDesc`}
											/>
										</p>
									) : (
										""
									)}
								</div>
							)}
						</div>
						{props.showHeader && (
							<div className="nodeActionButton">
								<Icons
									className={showOptionsMenu ? "rotate" : ""}
									name="micro-glyph-arrow-head"
									onMouseDown={(e) => {
										e.stopPropagation();
										e.preventDefault();
										setShowOptionsMenu(true);
									}}
								/>
							</div>
						)}
					</div>
					{props.editorMode === EDITOR_MODE.VALIDATION &&
						props.hasErrors === "errors" && (
							<Icons
								className="the-svg-icons validation error"
								name="micro-glyph-warning"
								type="glyph"
							/>
						)}
					{props.editorMode === EDITOR_MODE.VALIDATION &&
						props.hasErrors === "resolved" && (
							<Icons
								className="the-svg-icons validation resolved"
								name="micro-glyph-success"
								type="glyph"
							/>
						)}
					<div className={`coloredBase ${props.data.type}`}></div>
				</div>

				<Handle type="source" id="a1" position="bottom"></Handle>
			</div>
		</div>
	);
};
NodeBase.propTypes = {
	currentAutomationEvent: PropTypes.any,
	data: PropTypes.shape({
		desc: PropTypes.any,
		initialElement: PropTypes.bool,
		selected: PropTypes.any,
		tileTitle: PropTypes.any,
		type: PropTypes.string,
	}),
	desc: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	editorMode: PropTypes.string,
	footerIcon: PropTypes.string,
	hasErrors: PropTypes.string,
	params: PropTypes.string,
	selected: PropTypes.bool,
	showFooter: PropTypes.bool,
	showHeader: PropTypes.bool,
	tileTitle: PropTypes.any,
	updateAutomationEvent: PropTypes.func,
};

NodeBase.defaultProps = {
	showFooter: true,
	showHeader: true,
	content: null,
};
export default connect(
	(state, props) => {
		const getAutomationErrors = () => {
			const actionErrors = state.automations.automationEvents.filter(
				(event) => event.data.errors
			);
			const errors = [];
			state.automations.automationGeneralIssues &&
				errors.push(state.automations.automationGeneralIssues);
			actionErrors && errors.push(...actionErrors);
			return errors;
		};
		const getPreviousStepId = () => {
			let previousStepId = null;
			state.automations.automationEvents.forEach((e) => {
				if (isEdge(e) && e.target == props.id) {
					if (e.data.branchLabel) {
						previousStepId = `${e.source}_${e.data.branchLabel.toLowerCase()}`;
						return;
					}
					if (
						state.automations.automationEvents.filter(
							(ev) => ev.id == e.source
						)[0].data.initialElement
					) {
						return;
					}
					previousStepId = e.source;
				}
			});
			return previousStepId;
		};
		return {
			currentAutomationEvent: state.automations.automationEvents.filter(
				(event) => event.id === props.id
			)[0],
			editorMode: state.automations.editorMode,
			activeAutomation: state.automations.activeAutomation,
			automationErrors: getAutomationErrors(),
			selectedEventId: state.automations.selectedEventId,
			previousStepId: getPreviousStepId(),
			automationEvents: state.automations.automationEvents,
		};
	},
	(dispatch) =>
		bindActionCreators(
			{
				updateAutomationEvent,
				deleteAutomationEvent,
				updateSelectedEvent,
				openSubScene,
			},
			dispatch
		)
)(NodeBase);
